import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const BurgerMenuIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3332 2C16.8855 2 17.3332 1.55228 17.3332 1C17.3332 0.447715 16.8855 0 16.3332 0H1.6665C1.11422 0 0.666504 0.447715 0.666504 1C0.666504 1.55228 1.11422 2 1.6665 2H16.3332ZM16.3332 6C16.8855 6 17.3332 6.44772 17.3332 7C17.3332 7.55228 16.8855 8 16.3332 8H1.6665C1.11422 8 0.666504 7.55228 0.666504 7C0.666504 6.44772 1.11422 6 1.6665 6H16.3332ZM16.3332 12C16.8855 12 17.3332 12.4477 17.3332 13C17.3332 13.5523 16.8855 14 16.3332 14H1.6665C1.11422 14 0.666504 13.5523 0.666504 13C0.666504 12.4477 1.11422 12 1.6665 12H16.3332Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default BurgerMenuIcon;
